import MasterService from "./MasterService";

export const RoleUserService = {
    ...MasterService,

    addEditRoleDetails(params: object) {
        return this.post('/role/saveRoleFeatures', params)
    },

    getRoleList(params: object) {
        return this.post('/role/getRoleList', params)
    },

    getFeaturesList(params: object) {
        return this.post('/role/getAssignFeaturesList', params)
    },

    getUsersList(params: object) {
        return this.post('/user/getUserList', params)
    },

    updateStatus(params:object){
        return this.post('/role/roleDelete', params)
    }, 

    getUserManagementList(params: object) {
        return this.post('/user/userList', params)
    },

    saveUserData(params: object) {
        return this.post('/user/saveUserData', params)
    },
    userDelete(params: object) {
        return this.post('/user/userDelete', params)
    },

    getAssignedUsers(params: object) {
        return this.post('/user/assignUserList', params)
    },

    getAllUserListData(params: object){
        return this.post('/user/getAllUserList', params)
    }

}